import React from "react"

import {
  MobileMenuContainer,
  MobileMenuList,
  MobileMenuItem,
  MobileMenuLink,
  MobileMenuBtn,
  MobileMenuBtnLine,
} from "./MobileMenuElements"

import { ButtonPrimaryWhite } from "../../Buttons"

export const MobileMenu = ({ open, toggle }) => {
  return (
    <MobileMenuContainer open={open}>
      <MobileMenuList>
        <MobileMenuItem>
          <MobileMenuLink to="/">Home</MobileMenuLink>
        </MobileMenuItem>
        <MobileMenuItem>
          <MobileMenuLink to="/services">Services</MobileMenuLink>
        </MobileMenuItem>
        <MobileMenuItem>
          <MobileMenuLink to="/team">Meet your team</MobileMenuLink>
        </MobileMenuItem>
        <MobileMenuItem>
          <MobileMenuLink to="/clients">Portfolio</MobileMenuLink>
        </MobileMenuItem>
        <MobileMenuItem>
          <MobileMenuLink to="/learn">Learn</MobileMenuLink>
        </MobileMenuItem>
        <MobileMenuItem>
          <ButtonPrimaryWhite text={"Let's Chat"} link="/contact" />
        </MobileMenuItem>
      </MobileMenuList>
    </MobileMenuContainer>
  )
}

export const MobileMenuButton = ({ open, toggle }) => {
  return (
    <MobileMenuBtn onClick={toggle}>
      <MobileMenuBtnLine />
      <MobileMenuBtnLine />
      <MobileMenuBtnLine />
    </MobileMenuBtn>
  )
}
